import React, { useState } from 'react';

import useAppContext from 'flow/hooks/useAppContext';

import SettingRow from '../SettingRow';

import Toggle from 'flow/components/ui-components/Toggle';

import {
    getVideoConferenceWithSip,
    saveVideoConferenceWithSip,
} from 'flow/utils/browser-utils';

const VideoMeetingAsSIP = () => {
    const { i18next } = useAppContext();

    const [isEnabled, setEnabled] = useState(getVideoConferenceWithSip());

    const information =
        i18next.t('settings.conference.busy.in.conference.info') +
        ' ' +
        i18next.t('settings.conference.busy.in.conference.off.info');

    const handleToggle = (value: boolean) => {
        saveVideoConferenceWithSip(value);
        setEnabled(value);
    };

    return (
        <SettingRow
            dataTestId="handle-as-phone-call"
            cta={
                <Toggle
                    value={isEnabled}
                    onChange={handleToggle}
                    text={i18next.t('settings.conference.busy.in.conference')}
                />
            }
            information={information}
        >
            {i18next.t('settings.conference.busy.in.conference')}
        </SettingRow>
    );
};

export default VideoMeetingAsSIP;
